export const publicAsset = (fileName) => {
    const normalized = String(fileName || '').replace(/^\/+/, '');
    return `${import.meta.env.BASE_URL}${normalized}`;
};
